export default "__VITE_ASSET__RwW$z3Ig__"